import { Component, Input, ViewChild } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { BehaviorSubject } from 'rxjs';
import { DictionaryValue } from '@astrade/core';
import { DictionaryService } from './dictionary.service';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { FormFieldAbstractComponent } from '../form-field-abstract/form-field-abstract.component';

@Component({
  selector: 'astrade-form-field-autocomplete',
  template: `
    <mat-form-field fxFlex>
      <mat-label>{{label}}</mat-label>
      <input type="text" matInput [formControl]="control" [matAutocomplete]="auto"/>
      <button type="button" [disabled]="!control.value" mat-icon-button matSuffix (click)="reset()"><mat-icon>cancel</mat-icon></button>
      <button type="button" *ngIf="(options$ | async).length > 0" mat-icon-button matSuffix (click)="openDropDownList()"><mat-icon>arrow_drop_down</mat-icon></button>
      <button type="button" *ngIf="hint" [matTooltip]="hint" matTooltipClass="hint" mat-icon-button matSuffix><mat-icon>help</mat-icon></button>
      <!--<button type="button" mat-icon-button matSuffix (click)="openDialog()"><mat-icon>open_in_new</mat-icon></button>-->
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="renderValue">
        <mat-option *ngFor="let option of options$ | async" [value]="option">
          <span>{{option.name}}</span><!--<small> | ID: {{option.id}}</small>-->
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  `
})
export class FormFieldAutocompleteComponent extends FormFieldAbstractComponent {
  @Input() dictionaryId: string;

  @ViewChild(MatAutocompleteTrigger, {read: MatAutocompleteTrigger}) inputAutoComplete: MatAutocompleteTrigger;

  options$ = new BehaviorSubject<DictionaryValue[]>([]);

  constructor(
    private readonly dictionaryService: DictionaryService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.dictionaryId) {
      this.dictionaryService.getInitialValues(this.dictionaryId).subscribe(value => {
        this.options$.next(value);
      })
    }

    this.control.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      filter(value => typeof value === 'string' || value === ''),
      switchMap(searchTerm => {
        console.log(searchTerm);
        if (((searchTerm as string)?.length ?? 0) > 0) {
          return this.dictionaryService.search(this.dictionaryId, searchTerm);
        }

        return this.dictionaryService.getInitialValues(this.dictionaryId);
      })
    ).subscribe(value => {
      this.options$.next(value);
    });
  }

  renderValue(value: any): string {
    return value?.name ?? '';
  }

  reset(): void {
    this.control.setValue('');
  }

  openDropDownList(): void {
    this.inputAutoComplete.openPanel();
  }

  openDialog(): void {
    // TODO: implement
  }
}
